import "typeface-open-sans";
import FontFaceObserver from "fontfaceobserver";
import PropTypes from "prop-types";
import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { getScreenWidth, timeoutThrottlerHandler } from "../utils/helpers";
import Header from "../components/Header";
import _JSXStyle from 'styled-jsx/style';

if (typeof global !== 'undefined') {
  Object.assign(global, { _JSXStyle })
}

export const ThemeContext = React.createContext(null);
export const ScreenWidthContext = React.createContext(0);
export const FontLoadedContext = React.createContext(false);

import themeObjectFromYaml from "../theme/theme.yaml";
import Drawer from "../components/Drawer/Drawer";
const config = require("../../content/meta/config");

class Layout extends React.Component {
  constructor() {
    super();

    this.state = {
      font400loaded: false,
      font600loaded: false,
      screenWidth: 0,
      headerMinimized: false,
      theme: themeObjectFromYaml,
      drawerOpen: false
    };

    if (typeof window !== `undefined`) {
      this.loadFont("font400", "Open Sans", 400);
      this.loadFont("font600", "Open Sans", 600);
    }
  }

  timeouts = {};

  componentDidMount() {
    this.setState({
      screenWidth: getScreenWidth(),
      drawerOpen: false
    });
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this.resizeThrottler, false);
    }
  }

  resizeThrottler = () => {
    return timeoutThrottlerHandler(this.timeouts, "resize", 100, this.resizeHandler);
  };

  resizeHandler = () => {
    this.setState({ screenWidth: getScreenWidth() });
  };

  isHomePage = () => {
    if (this.props.location.pathname === "/") {
      return true;
    }

    return false;
  };

  loadFont = (name, family, weight) => {
    const font = new FontFaceObserver(family, {
      weight: weight
    });

    font.load(null, 10000).then(
      () => {
        this.setState({ [`${name}loaded`]: true });
      },
      () => {
        console.log(`${name} is not available`);
      }
    );
  };


  toggleDrawer = e => {
    this.setState(prevState => ( { drawerOpen: !prevState.drawerOpen } ))
  };

  render() {
    return (
      <StaticQuery
        query={graphql`
          query LayoutgQuery {
            pages: allMarkdownRemark(
              filter: { fileAbsolutePath: { regex: "//pages//" }, fields: { prefix: { regex: "/^\\d+$/" } } }
              sort: { fields: [fields___prefix], order: ASC }
            ) {
              edges {
                node {
                  fields {
                    slug
                    prefix
                  }
                  frontmatter {
                    title
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { children } = this.props;
          const {
            pages: { edges: pages }
          } = data;
          return (
            <ThemeContext.Provider value={this.state.theme}>
              <FontLoadedContext.Provider value={this.state.font400loaded}>
                <ScreenWidthContext.Provider value={this.state.screenWidth}>
                  <React.Fragment>
                    <Header
                      drawerOpen={this.state.drawerOpen}
                      className={this.state.drawerOpen ? "page-wrapper slide" : "page-wrapper"}
                      path={this.props.location.pathname}
                      pages={pages}
                      theme={this.state.theme}
                      drawerToggleFunction={this.toggleDrawer}
                    />
                    <Drawer closeHandler={this.toggleDrawer} theme={this.state.theme} items={config.menuLinks}  visible={this.state.drawerOpen} subtitle={config.headerSubTitle} title={config.headerTitle} titleLink={"/"}/>
                    <main className={this.state.drawerOpen ? "page-wrapper slide" : "page-wrapper"}>

                        {children}

                    </main>

                    {/* --- STYLES --- */}
                    {/*language=SCSS*/}
                    <style jsx>{`
                      article, aside, details, figcaption, figure, footer, header, hgroup, main, menu, nav, section, summary {
                          display: block;
                      }
                      main {
                        min-height: 80vh;
                      }
                      .page-wrapper {

                        position: relative;
                        left: 0;
                        -webkit-transition: left 500ms ease-in-out;
                        -moz-transition: left 500ms ease-in-out;
                        transition: left 500ms ease-in-out;
                        -webkit-transform: translate3d(0, 0, 0);
                      }
                      .slide {
                          cursor: pointer;
                          left: -400px
                      }
                    `}</style>
                    {/*language=SCSS*/}
                    <style jsx global>{`
                      html {
                        box-sizing: border-box;
                      }
                      *,
                      *:after,
                      *:before {
                        box-sizing: inherit;
                        margin: 0;
                        padding: 0;
                      }
                      body {
                        font-family: ${this.state.font400loaded
                          ? "'Open Sans', sans-serif;"
                          : "Arial, sans-serif;"};
                      }
                      ::selection {
                        background: ${this.state.theme.colour.grey.darkest};
                        color: #fff;
                      }
                      h1,
                      h2,
                      h3 {
                        font-weight: ${this.state.font600loaded ? 600 : 400};
                        line-height: 1.1;
                        letter-spacing: -0.03em;
                        margin: 0;
                      }
                      h1 {
                        letter-spacing: -0.04em;
                      }
                      p {
                        margin: 0;
                      }
                      strong {
                        font-weight: ${this.state.font600loaded ? 600 : 400};
                      }
                      a {
                        text-decoration: none;
                        color: #666;
                      }
                      main {
                        width: auto;
                        display: block;
                      }
                    `}</style>
                  </React.Fragment>
                </ScreenWidthContext.Provider>
              </FontLoadedContext.Provider>
            </ThemeContext.Provider>
          );
        }}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default Layout;

//eslint-disable-next-line no-undef
/*
export const postQuery = graphql`
  query LayoutQuery {
    pages: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "//pages//" }, fields: { prefix: { regex: "/^\\d+$/" } } }
      sort: { fields: [fields___prefix], order: ASC }
    ) {
      edges {
        node {
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            menuTitle
          }
        }
      }
    }
    footnote: markdownRemark(fileAbsolutePath: { regex: "/footnote/" }) {
      id
      html
    }
  }
`;

*/
//
// export const query = graphql`
//   query LayoutQuery {
//     {
//       pages: allMarkdownRemark(filter: { fields :{ slug : {  eq : "/${
//         this.props.location.pathname
//       }/" } }}) {
//         edges {
//           node {
//             id
//             fields {
//               slug
//             }
//             frontmatter {
//               cover {
//                 id
//               }
//             }
//           }
//         }
//       }
//     }
//   }
// `;
